import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Componentes
import CatalogDerivados from './CatalogDerivados';

const Catalog = ({ cart, onAddToCart }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('abejas');

  useEffect(() => {
    const hash = location.hash;
    if (hash === '#material') {
      setActiveTab('material');
    } else {
      setActiveTab('abejas');
    }
    window.scrollTo(0, 0);
  }, [location]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    navigate(`#${tab}`);
  };

  return (
    <div className="min-h-screen bg-[#FFFBF0] dark:bg-[#1C1B17] pt-32 pb-20 relative transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Encabezado */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-black text-[#594400] dark:text-[#FFD54F] mb-4 uppercase tracking-wide">
            {activeTab === 'abejas' ? 'Derivados de las Abejas' : 'Material Apícola'}
          </h1>
          <div className="w-24 h-1.5 bg-yellow-500 dark:bg-[#FFD54F] mx-auto rounded-full"></div>
        </div>

        {/* Interruptor (Switch) estilo Material Design 3 */}
        <div className="flex justify-center mb-16">
          <div className="inline-flex bg-white dark:bg-[#2A2821] p-2 rounded-full shadow-xl border border-yellow-100 dark:border-[#594400] scale-110 transition-all duration-300">
            <button
              onClick={() => handleTabChange('abejas')}
              className={`px-8 md:px-12 py-3 rounded-full font-bold transition-all duration-300 ${
                activeTab === 'abejas' 
                  ? 'bg-yellow-500 dark:bg-[#FFD54F] text-white dark:text-[#1C1B17] shadow-md'
                  : 'text-[#594400] dark:text-[#FFD54F]/60 hover:bg-yellow-50 dark:hover:bg-[#594400]/20'
              }`}
            >
              Derivados
            </button>
            <button
              onClick={() => handleTabChange('material')}
              className={`px-8 md:px-12 py-3 rounded-full font-bold transition-all duration-300 ${
                activeTab === 'material' 
                  ? 'bg-yellow-500 dark:bg-[#FFD54F] text-white dark:text-[#1C1B17] shadow-md'
                  : 'text-[#594400] dark:text-[#FFD54F]/60 hover:bg-yellow-50 dark:hover:bg-[#594400]/20'
              }`}
            >
              Material
            </button>
          </div>
        </div>

        {/* Renderizado Condicional */}
        <div className="animate-fade-up">
          {activeTab === 'abejas' ? (
            <CatalogDerivados cart={cart} onAddToCart={onAddToCart} />
          ) : (
            /* 👇 VISTA LLAMATIVA DE "PRÓXIMAMENTE" 👇 */
            <div className="flex flex-col items-center justify-center py-20 px-4 text-center bg-white dark:bg-[#2A2821] rounded-[3rem] border-2 border-dashed border-yellow-400 dark:border-[#594400] shadow-sm">
              
              {/* Icono Hexagonal Animado */}
              <div className="mb-8">
                <div 
                  className="w-32 h-32 bg-yellow-500 dark:bg-[#FFD54F] flex items-center justify-center shadow-2xl animate-pulse"
                  style={{ clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
                >
                  <span className="text-6xl">🛠️</span>
                </div>
              </div>

              <h2 className="text-4xl md:text-5xl font-black text-yellow-950 dark:text-yellow-500 mb-6 uppercase tracking-tighter">
                ¡Próximamente Disponible!
              </h2>
              
              <p className="text-xl text-yellow-900 dark:text-[#FFE082]/90 max-w-2xl mx-auto leading-relaxed font-medium mb-10">
                Estamos terminando de organizar nuestro catálogo de <strong>colmenas y material de madera</strong> para brindarte la mejor calidad en el servicio.
              </p>

            
              {/* Botón para regresar a lo que sí hay */}
              <button 
                onClick={() => handleTabChange('abejas')}
                className="bg-yellow-950 dark:bg-[#FFD54F] text-white dark:text-[#1C1B17] px-10 py-4 rounded-full font-black uppercase tracking-widest transition-transform hover:scale-105 shadow-xl"
              >
                Ver Derivados Disponibles
              </button>

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Catalog;